import React from 'react';

type TProps = {
  isTintAvailable: boolean;
  dataForIntegration: string;
  openChooseColorModal: (event: React.MouseEvent<HTMLElement, MouseEvent>) => void;
  children: React.ReactElement;
  dataQa: string;
};

export const ButtonWrapperForIntegration = ({
  isTintAvailable,
  dataForIntegration,
  openChooseColorModal,
  children,
  dataQa,
}: TProps) => (
  <tint-button
    data-qa={dataQa}
    disabled={isTintAvailable ? undefined : true}
    data-tint-button="1"
    data-tint-data={dataForIntegration}
    onClick={openChooseColorModal}
  >
    {children}
  </tint-button>
);
